import { Button } from '@advanza/ui'
import {
    formatKeywordMappingCount,
    selectedCountLabel,
} from 'components/keywordMappings/keywordMappingBulk'
import { KEYWORD_MAPPING_FOCUS_RING } from 'components/keywordMappings/keywordMappingModel'

interface KeywordMappingBulkBarProps {
    selectedCount: number
    matchingFilter: boolean
    offerSelectAllCount: number | null
    disabled: boolean
    onSetH1: () => void
    onActivate: () => void
    onDeactivate: () => void
    onDelete: () => void
    onSelectAllMatching: () => void
    onClear: () => void
}

const KeywordMappingBulkBar = ({
    selectedCount,
    matchingFilter,
    offerSelectAllCount,
    disabled,
    onSetH1,
    onActivate,
    onDeactivate,
    onDelete,
    onSelectAllMatching,
    onClear,
}: KeywordMappingBulkBarProps) => {
    return (
        <div className="mb-3 flex flex-wrap items-center gap-2 rounded border border-solid border-[#d0d5dd] bg-[#f8fafc] px-3 py-2">
            <span className="text-sm font-semibold text-[#101828]" aria-live="polite">
                {selectedCountLabel(selectedCount, matchingFilter)}
            </span>
            {offerSelectAllCount !== null && (
                <button
                    type="button"
                    className={`text-sm font-semibold text-[#1d4ed8] underline ${KEYWORD_MAPPING_FOCUS_RING}`}
                    disabled={disabled}
                    onClick={onSelectAllMatching}>
                    Select all {formatKeywordMappingCount(offerSelectAllCount)} matching the filter
                </button>
            )}
            <Button
                type="button"
                name="text"
                className={KEYWORD_MAPPING_FOCUS_RING}
                disabled={disabled}
                onClick={onSetH1}>
                Set H1 text
            </Button>
            <Button
                type="button"
                name="text"
                className={KEYWORD_MAPPING_FOCUS_RING}
                disabled={disabled}
                onClick={onActivate}>
                Activate
            </Button>
            <Button
                type="button"
                name="text"
                className={KEYWORD_MAPPING_FOCUS_RING}
                disabled={disabled}
                onClick={onDeactivate}>
                Deactivate
            </Button>
            <Button
                type="button"
                name="text"
                className={KEYWORD_MAPPING_FOCUS_RING}
                disabled={disabled}
                onClick={onDelete}>
                Delete
            </Button>
            <Button
                type="button"
                name="text"
                className={KEYWORD_MAPPING_FOCUS_RING}
                disabled={disabled}
                onClick={onClear}>
                Clear selection
            </Button>
        </div>
    )
}

export default KeywordMappingBulkBar
